export default {
  "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات عنا"])},
  "Price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سعر:"])},
  "شنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["السبت"])},
  "یکشنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الأحد"])},
  "دوشنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الاثنين"])},
  "سه شنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يوم الثلاثاء"])},
  "چهارشنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الأربعاء"])},
  "پنج شنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يوم الخميس"])},
  "جمعه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["جمعة"])},
  "باز": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يفتح"])},
  "بسته": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مغلق"])}
}